import { crmResponse } from '../chat/api'
import type { CrmRequest, CrmRequestInit } from './CrmRequest'

/** The real CRM request for one account: the console's token, refreshed once on a 401. */
export function accountCrmRequest(accountId: string): CrmRequest {
  return async <T,>(path: string, init: CrmRequestInit = {}) => {
    const res = await crmResponse(path, {
      accountId,
      method: init.method ?? (init.body ? 'POST' : 'GET'),
      body: init.body,
      local: init.local,
    })
    const data = (await res.json().catch(() => ({ detail: 'Invalid JSON response' }))) as T
    return { status: res.status, data }
  }
}
